var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customers" }, [
    _c(
      "div",
      { staticClass: "new-invoice concepts box wrapper-products" },
      [
        _c("div", { staticClass: "title-container is-flex" }, [
          _c(
            "h3",
            {
              staticClass:
                "title is-centered is-4 has-text-primary title-products"
            },
            [_vm._v("\n        Productos\n      ")]
          ),
          _c(
            "div",
            { staticClass: "field is-centered" },
            [
              _c(
                "BTooltip",
                { attrs: { label: "Agregar partida", type: "is-success" } },
                [
                  !_vm.disabled
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "button add-concept is-success is-rounded",
                          on: { click: _vm.addRow }
                        },
                        [_c("BIcon", { attrs: { icon: "plus" } })],
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _c("AppPagination", {
          staticClass: "is-centered",
          attrs: {
            "current-page": _vm.currentPage,
            "buttons-max": _vm.buttonsMax,
            "pages-total": _vm.totalPages
          },
          on: { change: _vm.goToPage }
        }),
        _c(
          "BTable",
          {
            attrs: { data: _vm.concepts, columns: _vm.columns },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function(props) {
                  return [
                    _c(
                      "span",
                      {
                        class: { "header-label": props.column.label === "SKU" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.column.label) +
                            "\n        "
                        )
                      ]
                    ),
                    props.column.meta
                      ? _c("AppTooltip", {
                          attrs: { label: props.column.meta }
                        })
                      : _vm._e()
                  ]
                }
              },
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "BTableColumn",
                      { attrs: { field: "label", internal: "" } },
                      [
                        _c("AppSelectSearch", {
                          staticClass: "product-service-key-field",
                          class: {
                            "selected-field":
                              _vm.selected === "sku-" + props.row.rowId
                          },
                          attrs: {
                            name: "label",
                            placeholder: "S012321A",
                            value: props.row.label,
                            disabled: _vm.isNew(props.row),
                            taggable: true,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            change: function($event) {
                              return _vm.onChangeIdentificationNumber(
                                $event,
                                props.row.rowId
                              )
                            },
                            focus: function($event) {
                              return _vm.onChangeSelected(
                                "sku-" + props.row.rowId
                              )
                            },
                            blur: _vm.onClearSelected
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "BTableColumn",
                      { attrs: { field: "description", internal: "" } },
                      [
                        _c("AppInputField", {
                          staticClass: "product-service-key-field",
                          class: {
                            "selected-field":
                              _vm.selected === "description-" + props.row.rowId
                          },
                          attrs: {
                            id: "description-" + props.row.rowId,
                            name: "description",
                            placeholder: "Refrigerador",
                            value: props.row.description,
                            disabled: _vm.isLoading || _vm.disabled,
                            maxlength: 1000,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            change: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            focus: function($event) {
                              return _vm.onChangeSelected(
                                "description-" + props.row.rowId
                              )
                            },
                            blur: _vm.onClearSelected
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "BTableColumn",
                      { attrs: { field: "productServiceKey", internal: "" } },
                      [
                        _c("AppSelectSearch", {
                          staticClass: "product-service-key-field",
                          class: {
                            "selected-field":
                              _vm.selected ===
                              "product-service-key-" + props.row.rowId
                          },
                          attrs: {
                            name: "productServiceKey",
                            placeholder: "Clave de producto o servicio",
                            value: _vm.productServiceKeyObj(
                              props.row.productServiceKey
                            ),
                            options: _vm.productServiceKeyCatalog,
                            disabled: _vm.isLoading || _vm.disabled,
                            "on-search": _vm.onSearch,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            change: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            focus: function($event) {
                              return _vm.onChangeSelected(
                                "product-service-key-" + props.row.rowId
                              )
                            },
                            blur: _vm.onClearSelected
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "BTableColumn",
                      { attrs: { field: "unitKey", internal: "" } },
                      [
                        _c("AppSelectSearch", {
                          staticClass: "product-service-key-field",
                          class: {
                            "selected-field":
                              _vm.selected === "unit-key-" + props.row.rowId
                          },
                          attrs: {
                            name: "unitKey",
                            placeholder: "Clave de unidad",
                            options: _vm.unitKeyCatalog,
                            value: _vm.unitKeyObj(props.row.unitKey),
                            disabled: _vm.isLoading || _vm.disabled,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            change: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            focus: function($event) {
                              return _vm.onChangeSelected(
                                "unit-key-" + props.row.rowId
                              )
                            },
                            blur: _vm.onClearSelected
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "BTableColumn",
                      { attrs: { field: "unit", internal: "" } },
                      [
                        _c("AppInputField", {
                          staticClass: "product-service-key-field",
                          attrs: {
                            name: "unitValue",
                            placeholder: "15.24",
                            type: "number",
                            step: "0.000001",
                            min: "0.000001",
                            disabled: _vm.isLoading || _vm.disabled,
                            value: props.row.unitValue,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            },
                            change: function($event) {
                              return _vm.onChange($event, props.row.rowId)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "BTableColumn",
                      { attrs: { field: "actions", internal: "" } },
                      [
                        _c(
                          "AppRadialMenu",
                          {
                            attrs: {
                              size: 36,
                              "item-size": 48,
                              radius: 60,
                              "angle-restriction": 60,
                              rotate: -30
                            }
                          },
                          [
                            _c(
                              "AppRadialMenuItem",
                              {
                                staticClass:
                                  "tooltip is-tooltip-success has-background-success has-text-white",
                                attrs: { "data-tooltip": "Guardar Producto" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "action-option",
                                    on: {
                                      click: function($event) {
                                        return _vm.save(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("BIcon", {
                                      staticClass: "action-option-icon",
                                      attrs: { icon: "content-save" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "AppRadialMenuItem",
                              {
                                staticClass:
                                  "tooltip is-tooltip-danger has-background-danger has-text-white",
                                attrs: { "data-tooltip": "Eliminar Producto" }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "action-option",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteRow(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c("BIcon", {
                                      staticClass: "action-option-icon",
                                      attrs: { icon: "delete" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          },
          [
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c(
                      "p",
                      [
                        _c("BIcon", {
                          attrs: { icon: "emoticon-sad", size: "is-large" }
                        })
                      ],
                      1
                    ),
                    _c("p", [_vm._v("No tienes ningún producto")])
                  ]
                )
              ])
            ])
          ],
          2
        ),
        _c("AppPagination", {
          staticClass: "is-centered",
          attrs: {
            "current-page": _vm.currentPage,
            "buttons-max": _vm.buttonsMax,
            "pages-total": _vm.totalPages
          },
          on: { change: _vm.goToPage }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }